import Swal from 'sweetalert2';

export const showTutorialWelcome = () => {
  return Swal.fire({
    title: '🎮 Welcome to Smartphone Inc.!',
    html: `
      <p>Would you like to take a guided tour of the game?</p>
      <p class="text-sm text-theme-text-muted mt-2">This will help you learn the essential mechanics and features.</p>
    `,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Start Tutorial',
    cancelButtonText: 'Skip Tutorial',
    confirmButtonColor: '#10b981',
    cancelButtonColor: '#6b7280',
    customClass: {
      popup: 'tutorial-welcome-popup',
      title: 'text-2xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};

export const showTutorialMessage = (message: string, title?: string) => {
  return Swal.fire({
    title: title || 'Tutorial',
    html: message,
    icon: 'info',
    confirmButtonText: 'Got it!',
    confirmButtonColor: '#10b981',
    customClass: {
      popup: 'tutorial-message-popup'
    }
  });
};

export const showTutorialComplete = () => {
  return Swal.fire({
    title: '🎉 Tutorial Complete!',
    html: `
      <p>You've completed the tutorial and learned the basics of Smartphone Inc.</p>
      <p class="text-sm text-theme-text-muted mt-2">The game is still in early development. More features are coming soon!</p>
      <p class="text-sm text-theme-text-muted mt-2">You can always access help through the menu if you need it.</p>
    `,
    icon: 'success',
    confirmButtonText: 'Start Playing!',
    confirmButtonColor: '#10b981',
    customClass: {
      popup: 'tutorial-complete-popup',
      title: 'text-2xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};

export const showConfirm = (
  message: string,
  title: string,
  options?: {
    confirmButtonText?: string;
    cancelButtonText?: string;
    icon?: 'info' | 'warning' | 'success' | 'error' | 'question';
  }
) => {
  return Swal.fire({
    title,
    html: message,
    icon: options?.icon || 'question',
    showCancelButton: true,
    confirmButtonText: options?.confirmButtonText || 'Yes',
    cancelButtonText: options?.cancelButtonText || 'No',
    confirmButtonColor: '#10b981',
    cancelButtonColor: '#6b7280',
    customClass: {
      popup: 'tutorial-confirm-popup',
      title: 'text-xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};

export const showError = (message: string, title?: string) => {
  return Swal.fire({
    title: title || 'Error',
    html: message,
    icon: 'error',
    confirmButtonText: 'OK',
    confirmButtonColor: '#ef4444',
    customClass: {
      popup: 'error-popup',
      title: 'text-xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};

export const showWarning = (message: string, title?: string) => {
  return Swal.fire({
    title: title || 'Warning',
    html: message,
    icon: 'warning',
    confirmButtonText: 'OK',
    confirmButtonColor: '#f59e0b',
    customClass: {
      popup: 'warning-popup',
      title: 'text-xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};

export const showInfo = (message: string, title?: string) => {
  return Swal.fire({
    title: title || 'Information',
    html: message,
    icon: 'info',
    confirmButtonText: 'OK',
    confirmButtonColor: '#3b82f6',
    customClass: {
      popup: 'info-popup',
      title: 'text-xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};

export const showSuccess = (message: string, title?: string) => {
  return Swal.fire({
    title: title || 'Success',
    html: message,
    icon: 'success',
    confirmButtonText: 'OK',
    confirmButtonColor: '#10b981',
    customClass: {
      popup: 'success-popup',
      title: 'text-xl font-bold',
      htmlContainer: 'text-left'
    }
  });
};